import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { copy, displayTitle } from '../data/website';
import { HeroFeatures } from './HeroFeatures';

export const Hero = () => <section id="top" className="cinematic-hero" data-testid="hero-section">
  <img className="hero-landscape" src="/media/bharat-hero.webp" alt="Cinematic artwork inspired by India's riverside heritage" fetchPriority="high" data-testid="hero-landscape" />
  <div className="hero-readability" aria-hidden="true" />
  <div className="hero-content-wrap">
    <motion.div className="hero-copy" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}>
      <p className="hero-eyebrow" data-testid="hero-eyebrow">{copy.tagline}</p>
      <h1 data-testid="hero-headline">
        <span className="hero-headline-lead">We create</span>
        <em className="hero-headline-accent">experiences.</em>
      </h1>
      <p className="hero-description" data-testid="hero-description">{copy.hero.intro}</p>
      <div className="hero-actions">
        <a className="button button-dark" href="#experiences" data-testid="hero-cta-explore">{copy.hero.cta}<ArrowRight size={17} /></a>
        <a className="text-link" href="#partner" data-testid="hero-cta-partner">{copy.partner.cta}<ArrowRight size={15} /></a>
      </div>
    </motion.div>
  </div>
  <div className="hero-annotation" aria-hidden="true"><span>Story to<br />experience</span><svg viewBox="0 0 70 70" fill="none"><path d="M8 5c35 2 46 22 43 51m-8-9 8 10 7-11" stroke="currentColor" strokeWidth="1.2" /></svg></div>
  <nav className="hero-journeys" aria-label="Our approach">
    {copy.approach.steps.map((step, i) => <a key={step.title} className={i === 0 ? 'is-active' : ''} href={`#approach-step-${i + 1}`} data-testid={`hero-approach-${i + 1}`}><span />{displayTitle(step.title)}</a>)}
  </nav>
  <HeroFeatures />
</section>;